export default /* graphql */ `
query($preview: Boolean) {
  liveEventCollection(preview: $preview, limit: 1, where:{isLive: true}) {
	items {
    sys { id }
    title
    isLive
    isLivestream
    # startDatetime
    # endDatetime
    youtubeUrl
    
    posterImage {
      sys { id }
      title
      url(transform: {
        width: 1400,
        format: JPG,
        quality: 90
      })

      large: url(transform: {
        width: 2800,
        format: JPG,
        quality: 90
      })
    }
    posterImageMobile {
      sys { id }
      title
      url(transform: {
        width: 320,
        format: JPG,
        quality: 90
      })
    }
    thumbnail {
      sys { id }
      title
      url(transform: {
        width: 550,
        height: 240,
        format: JPG,
        quality: 90
      })

      large: url(transform: {
        width: 1400,
        format: JPG,
        quality: 90
      })
    }
	}
  }
}
`
